// extracted by mini-css-extract-plugin
module.exports = {"dashRespHeader":"_1w90Stp3ginZOkGha4HhKd","actionBtn":"_3VW1Ly2-okkQCGQUakxd98","logo":"goJtv8YMd_hONDBWQDq2s"};